import {ChartSeriesMapOptions} from "@pg-mono/charts";

import {gdansk} from "./maps/gdansk";
import {krakow} from "./maps/krakow";
import {lodz} from "./maps/lodz";
import {poznan} from "./maps/poznan";
import {szczecin} from "./maps/szczecin";
import {warszawa} from "./maps/warszawa";
import {wroclaw} from "./maps/wroclaw";

export const maps: {
    [key: string]: ChartSeriesMapOptions[];
} = {
    warszawa,
    krakow,
    wroclaw,
    gdansk,
    poznan,
    lodz,
    szczecin
};
import {ChartSeriesMapOptions} from "@pg-mono/charts";

import {gdansk} from "./maps/gdansk";
import {krakow} from "./maps/krakow";
import {lodz} from "./maps/lodz";
import {poznan} from "./maps/poznan";
import {szczecin} from "./maps/szczecin";
import {warszawa} from "./maps/warszawa";
import {wroclaw} from "./maps/wroclaw";

export const maps: {
    [key: string]: ChartSeriesMapOptions[];
} = {
    warszawa,
    krakow,
    wroclaw,
    gdansk,
    poznan,
    lodz,
    szczecin
};
